import { defaultChartData } from '@constants/chart';
import { BarLabel, OrderedChartData, BarValue, XAxis } from '../../../types/barChart';

/**
 * Transforms the ordered chart data and bar configuration into a format that can be used by the bar chart component
 * @param orderedChartData - Array of ordered chart data by x axis
 */
export const transformBarChartData = ({
  orderedChartData,
}: {
  orderedChartData: OrderedChartData;
}) => {
  const firstItem = orderedChartData[0];

  if (!firstItem) return defaultChartData;

  const dataHash = orderedChartData.reduce<Record<XAxis, Record<BarLabel, BarValue>>>(
    (acc, { bars, xAxisLabel }) => {
      acc[xAxisLabel] = bars.reduce<Record<BarLabel, BarValue>>((barAcc, bar) => {
        barAcc[bar.label] = bar.value;

        return barAcc;
      }, {});

      return acc;
    },
    {},
  );

  // Transformed x axis
  const xAxisLabels = orderedChartData.map((data) => data.xAxisLabel);

  const datasets = firstItem.bars.map((bar) => ({
    label: bar.label,
    backgroundColor: bar.color ?? '#376fd0',
    data: xAxisLabels.map((xAxis) => dataHash[xAxis][bar.label] ?? 0),
  }));

  return {
    labels: xAxisLabels,
    datasets,
  };
};
